<template>
	<div class="page_content create_question" aria-label="Create Question Page Content">

		<div class="row page-heading border-0">
			<div class="col-8 input module_heading">
				<span class="icon-assessment float-left"></span>
				<span class="head_txt ace_sec_txt">
					<span v-if="reference">Edit Item</span>
					<span v-else>Create Item</span>
				</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button class="btn btn-primary float-right" id="listItem" @click="$router.push('/item/list')">List Item</button>
			</div>
		</div>

		<div class="section pad-sml">
			<div class="content-section mt-3 list_container" id="learnosity-author"></div>
		</div>

	</div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'createItem',
    props: ['reference'],
    mounted () {
      this.createLearnosityItem()
    },
    methods: {
      ...mapActions([
        'createItem'
      ]),
      createLearnosityItem () {
        this.createItem({router: this.$router, reference: this.reference})
      }
    }
  }
</script>

<style scoped>
  #listItem {
    margin-left: 50px;
  }
  .content-section {
	height: calc(100vh - 240px);
    overflow-y: auto;
	min-height:100px;
}
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/CreateItem.vue